import React from "react";
import "./FlowerField.css";
import { BLOOM_NAMES, LAYERS } from "./flowerScatter";
import FlowerShapes from "./FlowerShapes";

/**
 * FlowerField — the shared body of a flower-field SVG: the template <defs> and
 * the per-layer <use> instances. FlowerTurf (home meadow) and EdgeFlowers
 * (game-screen frame) each render one inside their own <svg> (which owns
 * sizing/viewBox/positioning), so the template ↔ <use> plumbing and the
 * per-instance bloom-hue classes live in one place. `idPrefix` keeps the two
 * fields' template ids distinct.
 */
export default function FlowerField({ templates, layers, idPrefix }) {
  return (
    <>
      <defs>
        {templates.map((t, i) => (
          <g key={i} id={`${idPrefix}-${i}`}>
            <FlowerShapes shapes={t.shapes} />
          </g>
        ))}
      </defs>
      {layers.map((uses, li) => (
        <g key={li} className={`flower-field__layer flower-field__layer--${LAYERS[li].name}`}>
          {uses.map((u, j) => (
            <use
              key={j}
              href={`#${idPrefix}-${u.ti}`}
              className={`flower-field__bloom--${BLOOM_NAMES[u.bi]}`}
              transform={`translate(${u.x.toFixed(1)} ${u.y.toFixed(1)}) scale(${u.sx.toFixed(3)} ${u.sy.toFixed(3)})`}
            />
          ))}
        </g>
      ))}
    </>
  );
}
